import * as React from 'react';
import styled, { css } from 'styled-components';
import { useMemo } from 'react';

import { Select } from 'components/common';
import useConfiguredDataLakes from 'data-lake/preview/hooks/useConfiguredDataLakes';
import usePluginEntities from 'hooks/usePluginEntities';

const StyledSelect = styled(Select)`
  min-width: 280px;
`;

const OptionContainer = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.spacings.xs};
  `,
);

const OptionIcon = styled.div`
  display: flex;
  align-items: center;
`;

const Option = ({ label, value }: { label: string; value: string }) => {
  const dataLakePlugins = usePluginEntities('dataLakeStorageTypes');
  const { dataLakes } = useConfiguredDataLakes();
  const optionDataLakeStorageType = dataLakes.find(({ id }) => id === value).storageType;
  const dataLakePlugin = dataLakePlugins.find(({ storageType }) => storageType === optionDataLakeStorageType);
  const Icon = dataLakePlugin.icon;

  return (
    <OptionContainer>
      <OptionIcon>
        <Icon />
      </OptionIcon>
      {label}
    </OptionContainer>
  );
};

const DataLakeTypeSelect = () => {
  const { selectDataLake, selectedDataLake, dataLakes } = useConfiguredDataLakes();
  const dataLakeOptions = useMemo(() => dataLakes.map(({ id, title }) => ({ label: title, value: id })), [dataLakes]);

  return (
    <StyledSelect
      id="dataLakeType"
      name="dataLakeType"
      placeholder="Select Data Lake Type"
      clearable={false}
      valueRenderer={Option}
      optionRenderer={Option}
      options={dataLakeOptions}
      onChange={selectDataLake}
      value={selectedDataLake.id}
    />
  );
};

export default DataLakeTypeSelect;
